





















import {Component, Vue} from 'vue-property-decorator';

interface Link {
    icon: string;
    destination: string;
}

@Component
export default class AppFooter extends Vue {
    private links: Link[] = [
        {
            icon: 'fab fa-linkedin',
            destination: 'https://www.linkedin.com/in/felipe-flor/',
        },
        {
            icon: 'fab fa-github',
            destination: 'https://github.com/FRFlor/cat-mouse',
        },
        {
            icon: 'fas fa-user-circle',
            destination: 'https://www.felipeflor.com',
        },
    ];
}
